import { ca } from '@cian/analytics';

export function trackSendFormSuccess() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'B2BLanding',
    action: 'Send',
    label: 'Form',
  });
}
